import { createContext } from 'react'

import { MetricsProperties } from './types'

export const MetricsContext = createContext({} as MetricsProperties)
